// extracted by mini-css-extract-plugin
export default {"addPlotContainer":"AddPlot_addPlotContainer__WFYLJ","addPlotForm":"AddPlot_addPlotForm__qTd5U","error":"AddPlot_error__5557T","success":"AddPlot_success__fQrUK"};